<template>
  <div class="panel panel-default">
    <div class="panel-heading">
      <label class="control-label">
        Ajuste automático de mensalidades
        <span
          class="icon--micro glyphicon glyphicon-info-sign"
          data-toggle="tooltip"
          title="Permite configurar se mensalidades pagas a mais (pagamento em excesso)
          ou a menos (pagamento insuficiente) possam ter essas diferenças transferidas
          para outra mensalidade em aberto."
        >
        </span>
      </label>
    </div>
    <div class="panel-body bill-adjustment-rules__form">
      <loading v-if="loading" full-parent size="small" />
      <checkbox-field
        label="Pagamento insuficiente"
        value="underpayment"
        v-model="underpaymentForm.get('enabled').value"
        :errors="underpaymentForm.get('enabled').errors"
        @input="emitUnderpaymentFormChanged('enabled')"
      />
      <div
        v-if="parseBoolean(underpaymentForm.get('enabled').value)"
        class="row"
      >
        <div class="col-md-4">
          <select-field
            label="Tipo"
            placeholder=" "
            :options="thresholdTypes"
            v-model="underpaymentForm.get('thresholdType').value"
            :errors="underpaymentForm.get('thresholdType').errors"
            @input="emitUnderpaymentFormChanged('thresholdType')"
          />
        </div>
        <div class="col-md-4">
          <money-field
            v-if="underpaymentForm.get('thresholdType').value === 'absolute'"
            label="Valor"
            v-model="underpaymentForm.get('thresholdValue').value"
            :errors="underpaymentForm.get('thresholdValue').errors"
            @input="emitUnderpaymentFormChanged('thresholdValue')"
          />
          <input-field
            v-if="underpaymentForm.get('thresholdType').value === 'percentage'"
            label="Porcentagem"
            input-group-text-append="%"
            :mask="['#.##','##.##','###.##']"
            v-model="underpaymentForm.get('thresholdValue').value"
            :errors="underpaymentForm.get('thresholdValue').errors"
            @input="emitUnderpaymentFormChanged('thresholdValue')"
          />
        </div>
      </div>
      <checkbox-field
        label="Pagamento excessivo"
        value="overpayment"
        v-model="overpaymentForm.get('enabled').value"
        :errors="overpaymentForm.get('enabled').errors"
        @input="emitOverpaymentFormChanged('enabled')"
      />
      <div
        v-if="parseBoolean(overpaymentForm.get('enabled').value)"
        class="row"
      >
        <div class="col-md-4">
          <select-field
            label="Tipo"
            placeholder=" "
            :options="thresholdTypes"
            v-model="overpaymentForm.get('thresholdType').value"
            :errors="overpaymentForm.get('thresholdType').errors"
            @input="emitOverpaymentFormChanged('thresholdType')"
          />
        </div>
        <div class="col-md-4">
          <money-field
            v-if="overpaymentForm.get('thresholdType').value === 'absolute'"
            label="Valor"
            v-model="overpaymentForm.get('thresholdValue').value"
            :errors="overpaymentForm.get('thresholdValue').errors"
            @input="emitOverpaymentFormChanged('thresholdValue')"
          />
          <input-field
            v-if="overpaymentForm.get('thresholdType').value === 'percentage'"
            label="Porcentagem"
            input-group-text-append="%"
            :mask="['#.##','##.##','###.##']"
            v-model="overpaymentForm.get('thresholdValue').value"
            :errors="overpaymentForm.get('thresholdValue').errors"
            @input="emitOverpaymentFormChanged('thresholdValue')"
          />
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import {
  CheckboxField, InputField, MoneyField, SelectField,
} from 'components/form';
import Loading from 'components/Loading';
import EnumsService from 'services/EnumsService';

export default {
  components: {
    CheckboxField,
    InputField,
    MoneyField,
    SelectField,
    Loading,
  },
  props: {
    underpaymentForm: {
      type: Object,
      required: true,
    },
    overpaymentForm: {
      type: Object,
      required: true,
    },
  },
  data() {
    return {
      loading: false,
      thresholdTypes: [],
    };
  },
  mounted() {
    this.loading = true;

    EnumsService.getBillAdjustmentThresholdTypes()
      .then((thresholdTypes) => {
        this.thresholdTypes = thresholdTypes;
      })
      .catch(() => {
        this.$router.push('/');
      })
      .finally(() => {
        this.loading = false;
      });
  },
  methods: {
    parseBoolean(str) {
      return /^true$/i.test(str);
    },
    emitUnderpaymentFormChanged(field) {
      this.$emit('underpayment-form-field-changed', { [field]: this.underpaymentForm.get(field).value });
    },
    emitOverpaymentFormChanged(field) {
      this.$emit('overpayment-form-field-changed', { [field]: this.overpaymentForm.get(field).value });
    },
  },
};
</script>
<style lang="scss" scoped>
  @import 'assets/stylesheets/utils/_spacing.sass';

  .bill-adjustment-rules__form {
    padding: $space-m $space-st $space-xxs $space-st;
    position: relative;
  }
</style>
